import React from "react";
import {withRouter} from "react-router-dom";
import {Col, Container, Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExclamation, faSpinner} from "@fortawesome/free-solid-svg-icons";
import {Button, Form, Input, Space, Popconfirm, Table, Drawer, Steps, Result, Spin, DatePicker, Select, TimePicker} from "antd";
import moment from "moment";
import Api from "../../../../services/Api";
import _ from "lodash";
import HelperGeneral from "../../../../helpers/HelperGeneral";
import Countdown, {zeroPad} from "react-countdown";
import UserInfo from "../../../auth/UserInfo";
import {trans} from "../../../../helpers/HelperGlobal";
import MaskedInput from "antd-mask-input";

import GiveGiftOrder from "./GiveGiftOrder";
import {setGlobalSpinner} from "../../../../services/redux/actions/GeneralAction";
import {connect} from "react-redux";
import {reduxStore} from "../../../../services/redux/ReduxIndex";

const {Step} = Steps
const {Option} = Select;


class GiveGift extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight,
            product_data: [],
            transactions: [],
            pagination: {
                current: 1,
                pageSize: 10,
            },
            loading: true,
            productInputLoading: false,
            sliders: [],
            sliderLoading: true,
            open: false,
            placement: 'bottom',
            step: 0,
            info: {},
            dateFilterType: 'month'
        };
        this.windowResize = this.windowResize.bind(this);
        this.productAddForm = React.createRef();
        this.productInput = React.createRef();


        const PickerWithType = ({type, onChange}) => {
            if (type === 'time') return <TimePicker onChange={onChange}/>;
            if (type === 'date') return <DatePicker onChange={onChange}/>;
            return <DatePicker picker={type} onChange={onChange}/>;
        };

        const {menuData} = reduxStore.getState().GeneralReducer
        let brandFilters = [];
        if (menuData && menuData?.lists.length > 0) {
            const productMenuData = _.filter(menuData?.lists, ['id', 'product'])
            let newProductMenuData = _.first(productMenuData)
            if (newProductMenuData?.submenu) {
                newProductMenuData?.submenu.map((v, i) => (
                    brandFilters.push({
                        text: v?.title,
                        value: v?.id
                    })
                ));
            }
        }
        this.product_history_column = [
            {
                title: 'İşlem Tarihi',
                dataIndex: 'date',
                sorter: false,
                width: 180,
                render: (name, record) => moment(record?.CreatedOn).format('DD.MM.YYYY HH:mm'),
                filterDropdown: props => (
                    <Space>
                        <Select value={this.state.dateFilterType} onChange={(value) => this.setState({dateFilterType: value})}>
                            <Option value="month">Ay</Option>
                            <Option value="year">Yıl</Option>
                        </Select>
                        <PickerWithType type={this.state.dateFilterType} onChange={(value) => {
                            const transactionStartDate = value ? moment.utc(value).startOf(this.state.dateFilterType).format("YYYY-MM-DD") : '';
                            const transactionEndDate = value ? moment.utc(value).endOf(this.state.dateFilterType).format("YYYY-MM-DD") : '';
                            const {pagination} = this.state;
                            //this.getTransactions({pagination},transactionStartDate,transactionEndDate);
                        }}/>
                    </Space>
                )
            },
            {
                title: 'Ürün adı',
                dataIndex: 'product_name',
                render: (name, record) => record?.OrderProduct?.Name,
            },
            {
                title: 'Ürün Kodu',
                dataIndex: 'pharmacy_code',
                width: 180,
                render: (name, record) => record?.ProductPointCode ?? '-',
            },
            {
                title: 'Marka',
                dataIndex: 'brand_name',
                width: 180,
                render: (name, record) => record?.Brand?.Name,
                filters: brandFilters,
            }
        ];

        this.timerProductAdd = null;
    }

    async componentDidMount() {
        window.addEventListener('resize', this.windowResize);

        const user = UserInfo.info()
        const {pagination} = this.state;
        //this.getTransactions({pagination});
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.windowResize);
    }

    windowResize = () => {
        this.setState({
            innerWidth: window.innerWidth,
            innerHeight: window.innerHeight,
        });
    }

    orderCheck = (e) => {
        setGlobalSpinner(true)
        const user = UserInfo.info();
        const data = {
            orderNumber: e.orderNumber,
            pharmacyId: user.Pharmacy.pharmacyId
        };
        Api.orderCheck(data).then(r => {
            let infoData = {};
            if (r?.data?.result) {
                infoData = r?.data?.result;
                infoData.deliveryCode = e.orderNumber;
            }

            this.setState({
                info: infoData,
                step: 1,
                open: true,
            }, () => {
                this.productAddForm?.current?.resetFields();
                setGlobalSpinner(false)
            })
        }).catch((e) => {
            setGlobalSpinner(false)
            HelperGeneral.alert(e)
        })
    }

    handleTableChange = (pagination, filters, sorter) => {
        this.getTransactions({
            sortField: sorter.field,
            sortOrder: sorter.order,
            pagination,
            ...filters,
        });
    }

    getTransactions = (params = {}, transactionStartDate = '', transactionEndDate = '') => {
        this.setState({loading: true}, () => {
            Api.getGiftTransactions(params.pagination.current, params.pagination.pageSize, transactionStartDate, transactionEndDate, params.brand_name).then(response => {
                const result = response.data.result;
                this.setState({
                    loading: false,
                    product_data: result.data,
                    pagination: {
                        ...params.pagination,
                        total: result.page.totalElements,
                    },
                });
            }).catch((e) => {
                this.setState({
                    loading: false,
                    productInputLoading: false,
                }, () => HelperGeneral.alert(e));
            });
            ;
        });
        setTimeout(() => {
            this.setState({productInputLoading: false});
        }, 2000);
    }

    onClose = () => {
        this.setState({open: false, step: 0});
    }

    componentDidUpdate(prevProps) {
        if (this.props.activeKey !== prevProps.activeKey) {
            const {pagination} = this.state;
            //this.getTransactions({pagination});
        }
    }

    render() {
        const {step, product_data, pagination, loading, open, transactions, placement, info} = this.state;
        let help = null
        return (
            <>
                <div className={'product-area mt-0 ' + (transactions.length > 0 ? 'processing' : '')}>
                    <Row className={'h-100'}>
                        <Col
                            className={'my-auto'}
                            xs={12}
                            sm={12}
                            md={12}
                            lg={true}
                        >
                            <div className={'description-area'}>
                                <p className={'t1'}>Teslimat numarasını giriniz</p>
                                <p className={'t2'}>Tüketiciye sms olarak gelen teslimat numarasını giriniz.</p>
                            </div>
                        </Col>
                        <Col
                            className={'my-auto'}
                            xs={12}
                            md={12}
                            lg={'auto'}
                        >
                            <Form onFinish={(e) => this.orderCheck(e)} ref={this.productAddForm}>
                                <Container>
                                    <Row className={'p-0'}>
                                        <Col
                                            xs={12}
                                            md={'auto'}
                                        >
                                            <Form.Item
                                                name="orderNumber"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Sipariş Numarası gerekli bir alan'
                                                    },
                                                ]}
                                            >
                                                <Input placeholder={"Teslimat Numarasını giriniz"}/>
                                            </Form.Item>
                                        </Col>
                                        <Col
                                            xs={12}
                                            md={true}
                                            style={{marginRight: '10px'}}
                                        >
                                            <Button htmlType={'submit'}>Hediye Ver</Button>
                                        </Col>
                                    </Row>
                                </Container>
                            </Form>
                        </Col>
                        <Col xs={12} className={'p-0'}>
                            <div className={'process-area'}>
                                {
                                    transactions.map((v, i) => (
                                        <div className={(v.error ? '' : '')} key={i}>
                                            <div>
                                                {
                                                    v.error && (
                                                        <Countdown
                                                            precision={0}
                                                            renderer={({minutes, seconds}) => (
                                                                <span className={'pe-2 countdown d-none'}>
                                                                    Kapanacak: {zeroPad(seconds)}
                                                                </span>
                                                            )}
                                                            onComplete={() => {
                                                                const transactions = _.remove(this.state.transactions, (v1, i1) => {
                                                                    return i1 !== i
                                                                });
                                                                this.setState({transactions: transactions})
                                                            }}
                                                            date={v.errorTime}
                                                            key={v.key}
                                                            autoStart={true}
                                                        />
                                                    )
                                                }
                                                <FontAwesomeIcon
                                                    className={'d-none'}
                                                    icon={v.error ? faExclamation : faSpinner}
                                                    spin={!v.error}
                                                />
                                            </div>
                                        </div>
                                    ))
                                }

                            </div>
                        </Col>
                    </Row>
                </div>


                <div className={'product-history box-history'}>
                    <h3>Hediye Verilen Ürünler</h3>
                    <Table
                        columns={this.product_history_column}
                        rowKey={record => record.transactionId}
                        dataSource={product_data}
                        pagination={pagination}
                        loading={false}
                        onChange={this.handleTableChange}
                    />
                </div>

                <Drawer
                    title="Hediye ürün teslim süreci"
                    placement={placement}
                    height={"80%"}
                    onClose={this.onClose}
                    visible={open}
                    extra={
                        <Space>

                        </Space>
                    }
                >

                    <div className={"row basket"}>
                        <div className={"col-9 mx-auto"}>
                            <Steps current={step}>
                                <Step title="Sipariş Numarası Doğrula" description=""/>
                                <Step title="Sipariş Seç" description=""/>
                                <Step title="Ürünleri Onayla" description=""/>
                                <Step title="Teslimat Sonucu" description=""/>
                            </Steps>
                        </div>
                    </div>

                    <div className={"row basket mt-5"}>

                        {
                            [1, 2].includes(step) && (
                                <div className={"col-12 col-md-8 mx-auto"}>
                                    <div className={"box p-lg-5 p-1"}>
                                        <GiveGiftOrder info={info} sendStep={(step) => {
                                            this.setState({step: step}, () => {
                                                this.getTransactions({pagination});
                                            })
                                        }}/></div>
                                </div>
                            )
                        }

                        {
                            step === 3 && (

                                <Result
                                    status="success"
                                    title="Teslimat Başarıyla Tamamlandı"
                                    subTitle={""}
                                    extra={[
                                        <Button type="primary" key="console"
                                                style={{height: 56}}
                                                onClick={() => {
                                                    this.props.sendCompletedGiftOperation("2");
                                                    this.setState({open: false})
                                                }}>
                                            Ana Sayfaya dön
                                        </Button>,
                                    ]}
                                />
                            )
                        }
                    </div>
                </Drawer>
            </>
        );
    }
}


const mapStateToProps = (state) => ({
    menuData: state.GeneralReducer.menuData,
})

export default withRouter(connect(mapStateToProps)(GiveGift))

